import React, {Component} from 'react';
import {request} from "../helper/APIUtils";
import {showAxiosError} from "../helper/helper";
import {SERVLET_PATH, VirtualHost} from "../constants";
import QueryEnvelopeModal from "./component/QueryEnvelopeModal";
import {Button, Tooltip} from "reactstrap";
import RequestMessageModal from "../accounting/requestmessage/RequestMessageModal";
import {Link} from "react-router-dom";
import DownloadRequestModal from "../components/DownloadRequestModal";
import VideoModal from "../components/VideoModal";
import "./Header.css";
import {showMediaIcons, showRedirectPortal} from "../helper/permission";
import DirectingToOtherPortalModal from "../accounting/directingtootherportal/DirectingToOtherPortalModal";
import {Image} from '../common/Image';
import "../layout/component/OngoingProcesses.css";

class Header extends Component {

	switchVideo = (e, video) => {
		this.setState({video: video, showHelpVideoModal: true});
		window.removeEventListener('resize', this.updateDimensions);
	};

	constructor(props) {
		super(props);

		this.state = {
			height: window.innerHeight,
			width: window.innerWidth,
			branches: [],
			branchIndex: 0,
			key: Math.random().toString(36),
			pbTopMargin: '-26px 20px',
			pmHeight: '0',
			checkBoxState: false,
			showHelpVideoModal: false,
			video: null,
			multiCompany: false,
			companyList: [],
			top: '-1800px',
			videos: [],
			desktopApplicationDownloadLinks: [],
			customerComment: [],
			zoomLevel: 100,
			showZoomLevel: false,
			showCustomPopup: false
		};

		this.modalRef = React.createRef();

		this.showReload = this.showReload.bind(this);
		this.switchBranch = this.switchBranch.bind(this);
		this.updateDimensions = this.updateDimensions.bind(this);
		this.defineProfileMenuHeightOrButtonTopMargin = this.defineProfileMenuHeightOrButtonTopMargin.bind(this);
		this.closeVideoModal = this.closeVideoModal.bind(this);
		this.openDownloadRequestModal = this.openDownloadRequestModal.bind(this);
		this.closeDownloadRequestModal = this.closeDownloadRequestModal.bind(this);
		this.getDesktopApplicationDownloadLinks = this.getDesktopApplicationDownloadLinks.bind(this);
		this.checkDateForInbox = this.checkDateForInbox.bind(this);
	}

	componentDidMount() {
		let self = this;
		self.checkDateForInbox();
		let currentUser = this.props.currentUser;
		let activeBranch = currentUser.branches[currentUser.activeBranchIndex];
		this.setState({
			branches: currentUser.branches,
			activeBranch: activeBranch,
			branchIndex: currentUser.activeBranchIndex,
			formattedName: currentUser.formattedName,
			name: currentUser.name, // User.firstName
		});
		window.addEventListener("resize", this.updateDimensions);
		window.addEventListener('resize', this.defineProfileMenuHeightOrButtonTopMargin)
		this.fetchHelpVideos();

		if (VirtualHost.conf.resourcePrefix === "eczacikart") {
			this.getDesktopApplicationDownloadLinks();

			let params = {
				url: '/customerComment/getPage?page=' + 0 + '&size=' + 4,
				method: "post"
			}

			request(params).then((response) => {
				this.setState({customerComment: response.data.content})
			}).catch((err) => {
			})
		}
		const savedZoom = localStorage.getItem('zoomValue');
		if (savedZoom) {
			document.body.style.zoom = savedZoom;
			this.setState({ zoomLevel: parseFloat(savedZoom) });
		} else {
			document.body.style.zoom = '100%';
		}
		document.addEventListener('mousedown', this.handleClickOutside);

	}

	checkDateForInbox = () => {
		const currentDateTime = new Date().toISOString();
		const lastInvoiceCheckDateTime = localStorage.getItem('lastInvoiceCheckDateTime');

		if (!lastInvoiceCheckDateTime || new Date(lastInvoiceCheckDateTime) < new Date(currentDateTime)) {
			request({
				url: `/customer/checkNewInvoices`,
				method: "get",
			}).then(response => {
				const receivedDate = response.data;

				if (receivedDate && new Date(receivedDate) > new Date(lastInvoiceCheckDateTime)) {
					this.setState({ showCustomPopup: true });
					localStorage.setItem('lastInvoiceCheckDateTime', new Date(receivedDate).toISOString());
				} else {
					localStorage.setItem('lastInvoiceCheckDateTime', currentDateTime);
				}
			}).catch(error => {
				console.error('API isteği sırasında hata oluştu:', error);
			});
		}
	}

	closePopup = () => {
		this.setState({ showCustomPopup: false });
	}

	handleClickOutside = (event) => {
		if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
			this.setState({ showCustomPopup: false });
		}
	};

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions);
		window.removeEventListener('resize', this.defineProfileMenuHeightOrButtonTopMargin)
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleZoomIn = () => {
		const currentZoom = this.state.zoomLevel;
		if (currentZoom < 150) {
			const newZoom = currentZoom + 10;
			document.body.style.zoom = newZoom + '%';
			this.setState({ zoomLevel: newZoom, showZoomLevel: true });

			localStorage.setItem('zoomValue', newZoom + '%');
			this.setAutoHideZoomLevel();
		}
	}

	handleZoomOut = () => {
		const currentZoom = this.state.zoomLevel;
		if (currentZoom > 50) {
			const newZoom = currentZoom - 10;
			document.body.style.zoom = newZoom + '%';
			this.setState({ zoomLevel: newZoom, showZoomLevel: true });

			localStorage.setItem('zoomValue', newZoom + '%');
			this.setAutoHideZoomLevel();
		}
	}

	setAutoHideZoomLevel = () => {
		setTimeout(() => {
			this.setState({ showZoomLevel: false });
		}, 2500);
	}

	fetchHelpVideos = () => {
		request({
			method: 'get',
			url: `/media/videos/${VirtualHost.conf.resourcePrefix}`
		}).then(response => {
			this.setState({ videos: response.data });
		}).catch(function (error) {
			console.log(error);
		});
	};

	updateDimensions(event) {
		let currentHeight = this.state.height;
		let currentWidth = this.state.width;

		if (currentHeight !== window.innerHeight || currentWidth !== window.innerWidth) {
			this.setState({
				height: window.innerHeight,
				width: window.innerWidth,
				key: Math.random().toString(36)
			});
		}
	}

	switchBranch(index) {
		if (this.state.branchIndex === index) return;

		let self = this;
		let formData = new FormData();
		formData.append("index", index);

		let options = {
			method: 'post',
			url: `/user/switchBranch`,
			data: formData,
		};

		request(options)
			.then(response => {
				let {branches} = self.state;

				self.setState({
					activeBranch: branches[index],
					branchIndex: index,
				});
				setTimeout(function () {
					window.location.href = SERVLET_PATH + "/";
				}, 100)
			})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	showReload() {
		//Reload gösterilmesini istemediğimiz sayfaların listesi
		return (this.props.location && !(this.props.location.indexOf("Create") !== -1 ||
			this.props.location.indexOf("Edit") !== -1 ||
			this.props.location.indexOf("despatch/t") !== -1 ||
			this.props.location.indexOf("despatch/s") !== -1 ||
			this.props.location.indexOf("suppliers") !== -1 ||
			this.props.location.indexOf("externalCustomer") !== -1 ||
			this.props.location.indexOf("homePage") !== -1 ||
			this.props.location.indexOf("edefterZipYukleme") !== -1 ||
			this.props.location.indexOf("xsltOlustur") !== -1 ||
			this.props.location.indexOf("kullaniciOlustur") !== -1 ||
			this.props.location.indexOf("yetkiGruplariYonetimi") !== -1 ||
			this.props.location === "/" ||
			this.props.location.indexOf("despatch/p") !== -1));
	}

	defineProfileMenuHeightOrButtonTopMargin() {

		let pmlHeight = document.getElementById('profileMenuList') ? document.getElementById('profileMenuList').offsetHeight : 0;

		let totalHeight;
		let margin;

		if (window.innerWidth < 992) {
			totalHeight = (pmlHeight + 60).toString() + 'px';

		} else {
			totalHeight = '0';
		}

		if (document.getElementById('profileMenuButton')) {
			if (document.getElementById('profileMenuButton').checked) {
				margin = (pmlHeight + 5).toString() + 'px' + ' ' + '20px';

			} else {
				margin = '-26px 20px';
			}

		} else {
			margin = '0'
		}

		return (
			this.setState({
				pmHeight: totalHeight,
				pbTopMargin: margin,
				top: '-' + totalHeight
			})
		)
	}

	setCheckboxState() {

		let currentCheckBoxState = this.state.checkBoxState;

		if ((document.getElementById('profileMenuButton').checked) !== currentCheckBoxState) {
			this.defineProfileMenuHeightOrButtonTopMargin()
		}

		this.setState({
			checkBoxState: document.getElementById('profileMenuButton').checked
		})

	}

	closeVideoModal() {
		window.addEventListener('resize', this.updateDimensions);
		this.setState({showHelpVideoModal: false})
	}

	openDownloadRequestModal() {
		window.removeEventListener('resize', this.updateDimensions);
		this.setState({downloadRequestModal: true})
	}

	closeDownloadRequestModal() {
		window.addEventListener('resize', this.updateDimensions);
		this.setState({downloadRequestModal: false})
	}

	getDesktopApplicationDownloadLinks() {
		request({
			method: 'get',
			url: `/desktopApplicationDownloadUrl/getDownloadLinks/`
		}).then(response => {
			this.setState({desktopApplicationDownloadLinks: response.data});
		}).catch(function (error) {
			console.log(error);
		});
	}

	render() {

		let right = this.state.width > 991 ? (this.props.offsetWidth === null || this.props.offsetWidth === 24) ? {
			float: 'right',
			marginRight: '17em'
		} : {
			float: 'right',
			marginRight: '3em'
		} : {float: 'right'};

		return !this.props.isAuthenticated ?
			<div/> :
			(
				<div key={this.state.key} className="topbar3 col-sm-12 navbar navbar-expand-lg navbar-transparent  navbar-absolute bg-primary" id="merdingen">

					<input type="checkbox" name="toggle" id="profileMenuButton" onClick={() => this.setCheckboxState()}/>
					<label htmlFor="profileMenuButton" style={{margin: this.state.pbTopMargin}}/>

					<div className="container-fluid">
						<div className="navbar-wrapper col-sm-5">
							<div className="navbar-toggle">
								<button type="button" className="navbar-toggler">
									<span className="navbar-toggler-bar bar1"/>
									<span className="navbar-toggler-bar bar2"/>
									<span className="navbar-toggler-bar bar3"/>
								</button>
							</div>
							<div className="navbar-brand d-flex" style={{color: '#404040'}}>
								<div>
									{(this.state.formattedName || this.state.name) + "-" + this.state.activeBranch }
								</div>
								{this.props && this.props.currentUser && this.props.currentUser.poorServiceList && this.props.currentUser.poorServiceList.length>0 &&
									<div className="b-navbar-alert" style={{paddingLeft:"10px",color:"#ef2922",textTransform:"none"}}>
										<div>Yeterli kontör bulunmayan hizmetlerinizin kullanımı kısıtlanmış olup,&nbsp;</div>
										<div>Hizmetlerin kullanımına devam etmek için kontör yükleme yapmanız gerekmektedir.</div>
										{/*<div>Yeterli kontör bulunmayan hizmetlerin kullanımı kısıtlanmıştır.</div>*/}
										{/*<div>&nbsp;Servisleri kullanabilmek için kontür yükleme işlemi yapınız!.</div>*/}
									</div>
								}
							</div>

							<div className="b-navbar-alert" style={{
								color: '#404040',
								fontSize: 11,
								margin: "auto"
							}}>
								<div id='zoomValue'>
									{this.state.showZoomLevel && (
										<p>
											Ekran Boyutu: {this.state.zoomLevel}%
										</p>
									)}
								</div>
							</div>

						</div>

						<div className="navbar-collapse justify-content-end pull-right profileMenu"
							 style={{height: this.state.pmHeight, top: this.state.checkBoxState ? '0' : this.state.top}} id="navigation">

							<div style={right}>
								<ul id='profileMenuList' className="navbar-nav" style={{border: 'none'}}>
									{this.state.customerComment.length > 0 && VirtualHost.conf.resourcePrefix === "eczacikart" &&
										<Link to="/customerComment">
											<button variant="danger" className="btn btn-danger"
													aria-haspopup="true"
													aria-expanded="false"
													title='Eczacılarımız EczacıPOS Hakkında Ne Diyor?'
													style={{
														border: 'none',
														outline: 'none',
														marginLeft: '-120px'
													}}>
												<p>Eczacılarımız EczacıPOS Hakkında Ne Diyor?</p>
											</button>
										</Link>
									}
									{VirtualHost.conf.resourcePrefix === "eczacikart" && this.state.desktopApplicationDownloadLinks && this.state.desktopApplicationDownloadLinks.length > 0 &&
										<li className="nav-item dropdown" id="eczacikartDesktopApplication">
											<button type="button"
													id="eczacikartDesktopApplicationButton"
													data-toggle="dropdown" aria-haspopup="true"
													aria-expanded="false"
													style={{
														color: window.innerWidth < 992 ? "white" : '#525252',
														background: 'transparent',
														border: 'none',
														outline: 'none'
													}} className="nav-link navbar-contidional"
													rel="tooltip">
												Masaüstü Uygulamasını İndir <i className="fas fa-arrow-circle-down"/>
											</button>
											<div className="dropdown-menu dropdown-menu-left dropdown-scroll"
												 aria-labelledby="eczacikartDesktopApplicationButton">
												{
													this.state.desktopApplicationDownloadLinks.map((item, index) =>
														<a key={index} className="dropdown-item"
														   onClick={(e) => window.open(item.url)}>{item.applicationSystemVersion + " Bit"}</a>)
												}
											</div>
										</li>
									}

									{showMediaIcons() && (VirtualHost.conf.resourcePrefix !== "mbtfatura") &&
										<a className="nav-link"
										   href="https://www.youtube.com/@kolaysoftteknoloji6105" target="_blank"
										   style={{color: window.innerWidth < 992 ? "white" : '#525252'}}>
											<i className="fab fa-youtube" style={{
												fontSize: '23px'
											}}
											/>
										</a>
									}
									{showMediaIcons() &&
										(VirtualHost.conf.resourcePrefix === "mbtfatura" ?
										<a className="nav-link"
										   href="https://www.instagram.com/mbt.fatura/" target="_blank"
										   style={{color: window.innerWidth < 992 ? "white" : '#525252'}}>
											<i className="fab fa-instagram" style={{
												fontSize: '23px'
											}}
											/>
										</a>
										:
										<a className="nav-link"
										   href="https://www.instagram.com/kolaysoft/" target="_blank"
										   style={{color: window.innerWidth < 992 ? "white" : '#525252'}}>
											<i className="fab fa-instagram" style={{
												fontSize: '23px'
											}}
											/>
										</a>
										)
									}

									{showMediaIcons() && VirtualHost.conf.resourcePrefix === "mbtfatura" &&
										<a className="nav-link"
										   href="https://www.facebook.com/MBTFatura" target="_blank"
										   style={{color: window.innerWidth < 992 ? "white" : '#525252'}}>
											<i className="fab fa-facebook" style={{
												fontSize: '23px'
											}}
											/>
										</a>
									}

									{showMediaIcons() && VirtualHost.conf.resourcePrefix === "mbtfatura" &&
										<a className="nav-link"
										   href="https://www.linkedin.com/company/mbtfatura/" target="_blank"
										   style={{color: window.innerWidth < 992 ? "white" : '#525252'}}>
											<i className="fab fa-linkedin" style={{
												fontSize: '23px'
											}}
											/>
										</a>
									}

									{this.state.videos && this.state.videos.length > 0 &&
										<li className="nav-item dropdown" id='eczaciHelpButton'>
											<button className="nav-link navbar-contidional"
													id="videosLink" data-toggle="dropdown" aria-haspopup="true"
													aria-expanded="false"
													title='Yardımcı Videolar'
													style={{
														color: window.innerWidth < 992 ? "white" : '#525252',
														background: 'transparent',
														border: 'none',
														outline: 'none'
													}}>
												{window.innerWidth < 992 &&
													<i className="fab fa-youtube"/>}
												<p>Yardımcı Videolar</p>
											</button>
											<div
												className="dropdown-menu dropdown-menu-right dropdown-scroll videosDropdown"
												aria-labelledby="videosLink">
												{
													this.state.videos.map((video, i) =>
														<a key={i} className="dropdown-item"
														   onClick={(e) => this.switchVideo(e, video)}>{video.title}</a>)
												}
											</div>
										</li>
									}


									<li id='zoomOut'>
										<button type="button" data-toggle="tooltip" style={{
											marginLeft: '3px',
											border: 'none',
											cursor: 'pointer',
											background: "none",
											color: window.innerWidth < 992 ? "white" : '#525252'
										}} className="float-left"
												onClick={this.handleZoomOut}
												rel="tooltip">
											<Image className={"simple-text logo-mini " + this.props.spin}
												   src={process.env.REACT_APP_CONTEXT_NAME + "/image/" + (!this.props.spin ? "zoom-out.png" : "zoom-out.png")}
												   style={{
													   paddingTop: '0px',
													   width: '19px',
													   marginTop: '12px',
													   marginRight: '10px'
												   }}

											/>

										</button>
									</li>

									<li id='zoomIn'>
										<button type="button" data-toggle="tooltip" style={{
											marginLeft: '3px',
											border: 'none',
											cursor: 'pointer',
											background: "none",
											color: window.innerWidth < 992 ? "white" : '#525252'
										}} className="float-left"
												onClick={this.handleZoomIn}
												rel="tooltip">
											<Image className={"simple-text logo-mini " + this.props.spin}
												   src={process.env.REACT_APP_CONTEXT_NAME + "/image/" + (!this.props.spin ? "zoom-in.png" : "zoom-in.png")}
												   style={{
													   paddingTop: '0px',
													   width: '19px',
													   marginTop: '12px',
													   marginRight: '10px'
												   }}

											/>
										</button>
									</li>

									{this.showReload() &&
										<li id='reloadButton'>
											<button type="button" data-toggle="tooltip" style={{
												marginLeft: '3px',
												border: 'none',
												cursor: 'pointer',
												background: "none",
												color: window.innerWidth < 992 ? "white" : '#525252'
											}} className=" float-left"
													onClick={(e) => this.props.reload(true, "header")}
													rel="tooltip">
												<Image className={"simple-text logo-mini " + this.props.spin}
													   src={process.env.REACT_APP_CONTEXT_NAME + "/image/" + (!this.props.spin ? "refresh_blue.png" : "refresh_blue.png")}
													   style={{
														   paddingTop: '0px',
														   width: '19px',
														   marginTop: '12px',
														   marginRight: '10px'
													   }}

												/>
												{window.innerWidth < 992 &&
													<p>Yenile</p>}

											</button>
										</li>
									}

									<li className="nav-item dropdown" href="#" id='downloadRequestButton'>
										<a className="nav-link"
										   onClick={this.openDownloadRequestModal}
										   data-toggle="tooltip" rel='tooltip'
										   title='Bekleyen İndirmeler' id="downloadRequests"
										   style={{color: window.innerWidth < 992 ? "white" : '#525252'}}>
											<i className="fas fa-download"/>
											<p>
												<span className="d-lg-none d-md-block">İndirmeler</span>
											</p>
										</a>
										<Tooltip placement="bottom" isOpen={this.props.showDownloadRequestTooltip}
												 target="downloadRequests">
											İsteğiniz sıraya alındı
										</Tooltip>
									</li>

									{this.props.currentUser && ([3, 4, 5].includes(this.props.currentUser.roleId) || this.props.currentUser.adminUser) &&
										<li className="nav-item dropdown" href="#" id='requestButton'>
											<a className="nav-link"
											   onClick={(e) => this.setState({requestMessageModal: true})}
											   style={{color: window.innerWidth < 992 ? "white" : '#525252'}}>
												<i className="fa fa-envelope"/>
												<p style={{fontFamily: '"Montserrat", "Helvetica Neue", Arial, sans-serif'}}>
													<span className="d-lg-none d-md-block">İstek</span>
												</p>
											</a>
										</li>}

									<li className="nav-item dropdown" href="#" id='branchButton'>
										<button className="nav-link dropdown-toggle"
												id="branchesLink" data-toggle="dropdown" aria-haspopup="true"
												aria-expanded="false"
												style={{
													color: window.innerWidth < 992 ? "white" : '#525252',
													background: 'transparent',
													border: 'none',
													outline: 'none'
												}}>
											<i className="fa fa-building"/>
											<p>
												<span className="d-lg-none d-md-block">Şubeler</span>
											</p>
										</button>
										<div className="dropdown-menu dropdown-menu-right dropdown-scroll"
											 aria-labelledby="branchesLink">
											{
												this.state.branches.map((branch, i) =>
													<a key={i} className="dropdown-item"
													   style={this.state.branchIndex === i ? {background: 'lightblue'} : {}}
													   onClick={() => this.switchBranch(i)}>{branch}</a>
												)
											}
										</div>
									</li>

									<li className="nav-item dropdown" href="#" id='profileButton'>
										{this.props.currentUser && this.props.currentUser.vknTckn === "42283989566" ? (
											<>
												<button
													className="navbar-brand d-flex align-items-center dropdown-toggle"
													data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
													style={{
														color: '#404040',
														background: 'transparent',
														border: 'none',
														outline: 'none'
													}}>
													<p className="mb-0">{this.props.currentUser.name}
														<br/> VKN: {this.props.currentUser.vknTckn}</p>
												</button>
												<div className="dropdown-menu dropdown-menu-right"
													 aria-labelledby="navbarDropdownMenuLink">
													<Link to="/userProfile" style={{textDecoration: 'none'}}>
														<div className="dropdown-item">Kullanıcı Profili</div>
													</Link>
													<a className="dropdown-item" onClick={this.props.onLogout}>Çıkış</a>
													{this.props.impersonate &&
														<a className="dropdown-item"
														   onClick={() => this.props.onImpersonate(false)}>
															Kullanıcı Ekranından Çık
														</a>
													}
												</div>
											</>
										) : (
											<>
												<button className="nav-link dropdown-toggle" data-toggle="dropdown"
														aria-haspopup="true" id="navbarDropdownMenuLink"
														aria-expanded="false"
														style={{
															color: window.innerWidth < 992 ? "white" : '#525252',
															background: 'transparent',
															border: 'none',
															outline: 'none'
														}}>
													<i className={"fa fa-user" + (this.props.impersonate ? "-secret" : "")}/>
													<p><span className="d-lg-none d-md-block">Profil</span></p>
												</button>
												<div className="dropdown-menu dropdown-menu-right"
													 aria-labelledby="navbarDropdownMenuLink">
													<Link to="/userProfile" style={{textDecoration: 'none'}}>
														<div className="dropdown-item">
															{this.props.currentUser.name ? this.props.currentUser.name : this.props.currentUser.username}
														</div>
													</Link>
													<a className="dropdown-item" onClick={this.props.onLogout}>Çıkış</a>
													{this.props.impersonate &&
														<a className="dropdown-item"
														   onClick={() => this.props.onImpersonate(false)}>
															Kullanıcı Ekranından Çık
														</a>
													}
												</div>
											</>
										)}
									</li>

								</ul>
							</div>
						</div>
					</div>
					{this.state.queryModal &&
						<QueryEnvelopeModal modal={this.state.queryModal} toggle={this.toggleQueryEnvelopeModal}/>
					}
					{(this.state.requestMessageModal && this.props.entegratorConf && !showRedirectPortal(this.props.entegratorConf.identifier)) &&
						<RequestMessageModal modal={this.state.requestMessageModal}
											 adminUser={this.props.currentUser.entegrator}
											 listener={(e) => this.setState({requestMessageModal: false})}/>
					}

					{(this.state.requestMessageModal && this.props.entegratorConf && showRedirectPortal(this.props.entegratorConf.identifier)) &&
						<DirectingToOtherPortalModal modal={this.state.requestMessageModal}
													 adminUser={this.props.currentUser.entegrator}
													 listener={(e) => this.setState({requestMessageModal: false})}/>
					}
					{this.state.downloadRequestModal &&
						<DownloadRequestModal isOpen={this.state.downloadRequestModal}
											  close={this.closeDownloadRequestModal}/>
					}
					{this.state.showHelpVideoModal &&
						<VideoModal video={this.state.video} isOpen={this.state.showHelpVideoModal}
									close={this.closeVideoModal}/>
					}

					{this.state.showCustomPopup && (
						<div className="popup-background">
							<div className="popup" ref={this.modalRef}>
								<h2 className="popup-header">Yeni E-Fatura!</h2>
								<p className="popup-text">Yeni bir E-Faturanız var. İncelemek ister misiniz?</p>
								<div>
									<Button
										className="green-button"
										onClick={() => {
											this.setState({ showCustomPopup: false }, () => {
												window.location.href = "/accounting/eInvoiceInbox";
											});
										}}
									>
										Evet
									</Button>
									<Button
										className="red-button"
										onClick={this.closePopup}
									>
										Hayır
									</Button>
								</div>
							</div>
						</div>
					)}
				</div>
			);


	}
}

Header.defaultProps = {
	showOngoingProcesses: false
};

export default Header;